import { EPagination } from '../model/types';

export const CONFIG = {
	PER_PAGE: EPagination.MIN,
	PER_PAGE_OPTIONS: [EPagination.MIN, EPagination.MIDDLE, EPagination.MAX],
};
